import { TrackingEvent } from './types';

type State = {
  consentAnswered: boolean;
  consents: {
    adStorage: boolean;
    analyticsStorage: boolean;
  },
};

const state: State = {
  consentAnswered: false,
  consents: {
    adStorage: false,
    analyticsStorage: false,
  },
};

export const tracking = () => {
  const getConsentValue = (value: boolean) => (value ? 'granted' : 'denied');

  const changeConsents = (consents: Partial<State['consents']>) => {
    const newConsents = {
      ...state.consents,
      ...consents,
    };

    window.gtag(
      'consent', state.consentAnswered ? 'update' : 'default', {
        ad_storage: getConsentValue(newConsents.adStorage),
        analytics_storage: getConsentValue(newConsents.analyticsStorage),
      },
    );
  };

  const trackEvent = ({ event, currency, ...data }: TrackingEvent) => {
    window.gtag(
      'event', event, { data, currency: currency ?? 'EUR' },
    );
  };

  const trackPageView = ({ screen, page_title }: {
    screen: string; page_title?: string;
  }) => {
    window.gtag(
      'event', 'page_view', {
        screen,
        page_title: page_title ?? document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      },
    );
  };

  return {
    changeConsents,
    trackPageView,
    trackEvent,
  };
};
